import React from 'react';
import { SideInfoDevopsOptionsType } from '../../../../../model';
import {
  Layout,
  SideInformationComponent
} from '../../side-information-component';
import {
  getFeaturesList,
  getSocialProofImageURLs,
  getSocialProofProductLabel,
  SOCIAL_PROOF_TEXT_KEY_PREFIX
} from '../../utility/sign-up-layout-container';
import { useSignUpFormConfig } from '../../../../../hook';
import { FREE_EDITION_LABEL_KEY } from '../../../../../utility';
import { ProductKey } from '@atlassiansox/bxpkit-core';

export function SideInfoFirstImpressions({
  labels,
  productKeys,
  analyticsTrack,
  firstImpressionsImageUrls
}: SideInfoDevopsOptionsType) {
  const { bundle } = useSignUpFormConfig();
  const layout: Layout = 'first-impressions';

  const productKey = productKeys[0].product;

  const edition = productKey.includes(ProductKey.JIRA_CORE)
    ? productKeys[0].edition.toLowerCase()
    : FREE_EDITION_LABEL_KEY.toLowerCase();

  const productNameKey =
    bundle === 'jira'
      ? getSocialProofProductLabel(bundle)
      : getSocialProofProductLabel(productKey);

  const socialProofTextKey = SOCIAL_PROOF_TEXT_KEY_PREFIX + productNameKey;
  const socialProofText = labels[socialProofTextKey];

  const socialProofImageURLs =
    bundle === 'jira'
      ? getSocialProofImageURLs(bundle, firstImpressionsImageUrls)
      : getSocialProofImageURLs(productKey, firstImpressionsImageUrls);

  const featuresList = getFeaturesList({
    labels,
    productKey: productKeys[0].product,
    products: productKeys,
    featuresListEditionLabelKey: edition,
    migrationData: undefined,
    developerMode: undefined
  });

  return (
    <SideInformationComponent
      layout={layout}
      edition={edition}
      productKeys={productKeys}
      featuresList={featuresList}
      sideInfoHeader=""
      trialDurationNewSite=""
      trialDurationExistingSite=""
      imgSource=""
      isMobile={false}
      analyticsTrack={analyticsTrack}
      isExistingSiteFormShown={false}
      socialProof={{
        text: socialProofText,
        imgUrl: socialProofImageURLs.logoImage,
        heroUrl: socialProofImageURLs.heroImage
      }}
    />
  );
}
